import { useRef } from "react";
import Hero from "@/components/Hero";
import ProductsSection from "@/components/ProductsSection";
import BrandStory from "@/components/BrandStory";
import ImmersiveScroll from "@/components/ImmersiveScroll";
import ContactSection from "@/components/ContactSection";

export default function Home() {
  const scrollToProducts = () => document.getElementById("parfumuri")?.scrollIntoView({ behavior: "smooth" });

  return (
    <main data-testid="home-page">
      <Hero onExplore={scrollToProducts} />
      <ProductsSection />
      <BrandStory />
      <ImmersiveScroll />
      <ContactSection />
    </main>
  );
}
